import React, { useContext, useEffect, useState } from 'react'
import "./OnBoardingScreens.css";
import NewButton from '../../../NewComponents/NewButton';
import OnBoardingComponent from './OnBoardingComponent';
import { getQueryParam, useScreenTransition } from '../../../Hooks/useScreenTransition';
import { DataContext } from '../../../Context/DataContext';
import { useLocation } from 'react-router-dom';
import Ques1 from './Questions/Ques1';
import ORDERS from '../../../assets/onboarding-orders.png';
import TEAM from '../../../assets/onboard-teams.png';
import USERS from '../../../assets/onboard-users.png';
import Ques2 from './Questions/Ques2';
import Ques3 from './Questions/Ques3';
import Ques4 from './Questions/Ques4';
import Screen5 from './Questions/Screen5';


const OnBoardingScreen = ({windowSize}) => {
  const [currentScreen, setCurrentScreen] = useState(0);
  const { transitionTo } = useScreenTransition();


  const step = getQueryParam("step");

  useEffect(() => {
    if(step){
      if(step > 5 || step < 0){
        setCurrentScreen(0);
        return;
      }
      setCurrentScreen(Number(step));
    }else{
      setCurrentScreen(0)
    }
  }, [step])
  
  useEffect(() => {
    if(step <=5 && step >= 0){
      return;
    }
    const currentScreen = localStorage.getItem("currentOnBoardingScreen");
    if(currentScreen) {
      transitionTo(`/account/onboarding?step=${currentScreen}`)
    }
  }, [step])

  const onContinue = () => {
    localStorage.setItem("currentOnBoardingScreen", currentScreen + 1);
    transitionTo(`/account/onboarding?step=${currentScreen + 1}`);
  }
  
  return (
    <div className='onBoardingContainer'>
    {currentScreen === 0 && <OnBoardingComponent windowSize={windowSize} section2Img={ORDERS}>
      <div className="flex flex-[1] flex-col justify-center items-center">
          <img
              src={require("../../../assets/logo.png")}
              alt="Logo eVerbary"
              className="h-10 w-auto cursor-pointer absolute top-[20px] left-[40px]"
            />
        <div className=" shadow-md w-full max-w-[370px] flex flex-col justify-center items-start gap-[32px] bg-[#fff] rounded-[16px] h-max p-[32px]">
              <h2 className="onBoarding-title">👋 Welcome to eVerbary!</h2>
              <p className="onBoarding-description">
                Let’s set up your experience in under 60 seconds <br/>
                Answer a few quick questions so we can tailor your dashboard and support to match how your firm works.
              </p>
              <NewButton text="Contine Setup" icon={false} onClick={onContinue} width='100%'/>
            </div>
        </div>
    </OnBoardingComponent>}


    {currentScreen === 1 && <OnBoardingComponent section2Img={ORDERS}>
      {/* Question 1 */}
      <Ques1 windowSize={windowSize} currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} onContinue={onContinue}/>
    </OnBoardingComponent>}
    {currentScreen === 2 && <OnBoardingComponent section2Img={ORDERS}>
      {/* Question 2 */}
      <Ques2 windowSize={windowSize} currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} onContinue={onContinue}/>
    </OnBoardingComponent>}
    {currentScreen === 3 && <OnBoardingComponent section2Img={TEAM}>
      {/* Question 3 */}
      <Ques3 windowSize={windowSize} currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} onContinue={onContinue}/>
    </OnBoardingComponent>}
    {currentScreen === 4 && <OnBoardingComponent section2Img={USERS}>
      {/* Question 4 */}
      <Ques4 windowSize={windowSize} currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} onContinue={onContinue}/>
    </OnBoardingComponent>}

    {currentScreen === 5 && <OnBoardingComponent windowSize={windowSize} section2Img={require("../../../assets/icons/onboard-team.png")}>
      <Screen5/>
    </OnBoardingComponent>}
    </div>
  )
}

export default OnBoardingScreen;